module.exports = __webpack_public_path__ + "static/img/8.0235766.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/eng/8.png
// module id = BVyF
// module chunks = 0